export default "__VITE_ASSET__BgTGstLg__"